<template>
  <div class="section" v-if="frontdesk_team === 1">
    <h3 class="title is-3">Giving</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in giving_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
    <h3 class="title is-3">Event</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in event_total_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
    <h3 class="title is-3">Event Ticket</h3>
    <table class="table is-fullwidth">
      <tr>
        <th>Event</th>
        <th>Start Tickets</th>
        <th>Sold Tickets</th>
        <th>Remaining Tickets</th>
      </tr>
      <tr v-for="(event_row, index) in event_list" :key="index">
        <td v-text="event_row.title"></td>
        <td v-text="event_row.start_tickets"></td>
        <td v-text="event_row.sold_tickets"></td>
        <td v-text="event_row.remaining_tickets"></td>
      </tr>
    </table>
    <h3 class="title is-3">Event Ticket Complimentary</h3>
    <table class="table is-fullwidth">
      <tr>
        <th>Event Complimentary</th>
        <th>Start Tickets</th>
        <th>Sold Tickets</th>
        <th>Remaining Tickets</th>
      </tr>
      <tr v-for="(event_row, index) in event_complimentary_list" :key="index">
        <td v-text="event_row.title"></td>
        <td v-text="event_row.start_tickets"></td>
        <td v-text="event_row.sold_tickets"></td>
        <td v-text="event_row.remaining_tickets"></td>
      </tr>
    </table>
    <h3 class="title is-3">Settlement</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
      </tr>
      <tr v-for="(data_row, index) in settlement_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
    <div class="field">
      <div class="control">
        <label>Are you going to pass the tickets?</label>
      </div>
      <div class="control">
        <label class="radio" v-for="(pass_tickets_row, index) in pass_tickets_list" :key="index">
          <input type="radio" v-model="pass_tickets" :value="pass_tickets_row.id"> {{pass_tickets_row.title}}
        </label>
      </div>
    </div>
    <div class="field" v-show="pass_tickets === 1">
      <label>Service</label>
      <div class="control">
        <div class="select">
          <select v-model="service">
            <option value="">Select Service</option>
            <option v-for="(service_row, index) in service_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" @click="getModalConfirmation('Close Task', 'Are you sure want to close the task?', 'action')">Close Task</button>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
  <div class="section" v-else-if="frontdesk_team === 2">
    <div class="field">
      <div class="control">
        <label>Berapa banyak orang yang bertanya mengenai DATE?</label>
      </div>
      <div class="control">
        <input type="number" class="input" v-model="date_number">
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" @click="getModalConfirmation('Close Task', 'Are you sure want to close the task?', 'action')">Close Task</button>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      giving_list: [],
      event_total_list: [],
      event_list: [],
      event_complimentary_list: [],
      settlement_list: [],
      pass_tickets_list: [
        {
          id: 1,
          title: 'Yes'
        },
        {
          id: 0,
          title: 'No'
        }
      ],
      pass_tickets: 0,
      service_list: [],
      service: '',
      frontdesk_team: 0,
      date_number: 0
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.checkFrontdeskTeam()
  },
  methods: {
    // Untuk cek apakah TL ini adalah team Frontdesk atau bukan
    checkFrontdeskTeam () {
      var self = this
      self.flyGetSession('task/check_frontdesk_team').then(function (response) {
        if (response.data.response_code === 1) {
          self.frontdesk_team = response.data.data.frontdesk_team
          if (self.frontdesk_team === 1) {
            // Frontdesk
            self.checkReportClosed()
          } else if (self.frontdesk_team === 2) {
            // Floor Area
          } else {
            self.$router.push('/panel/profile')
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    checkReportClosed () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('task/check_report_closed')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          if (response.data.data === 0) {
            self.$geb.emit({id: 'alert_modal', title: 'Anda belum lock report.', content: 'Silahkan Lock Report anda terlebih dahulu.', button_text: 'OK'})
          } else {
            self.getFinishData()
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getFinishData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('task/get_finish_data')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.event_list = response.data.data.event_list
          self.event_complimentary_list = response.data.data.event_complimentary_list
          self.giving_list = response.data.data.giving_list
          self.event_total_list = response.data.data.event_total_list
          self.service_list = response.data.data.service_list
          self.settlement_list = response.data.data.settlement_list
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'action') {
        if (confirmData.flag === true) {
          var self = this
          self.$geb.emit({id: 'preloader', eventData: true})
          self.flyPostSession('task/close_task', {
            pass_tickets: this.pass_tickets,
            service: this.service,
            date_number: this.date_number
          }).then(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            if (response.data.response_code === 1) {
              self.$geb.emit({id: 'alert_modal', title: 'Close Task Success!', content: 'Close Task Success!', button_text: 'OK'})
              self.$router.push('/panel/task')
            } else {
              var result = response.data.message
              self.errors.clear()
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
            }
          }).catch(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            self.errorMessage(response)
          })
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/Finish.vue